import React from "react";
const BodyHeader = ({ title, description, children }) => {
  return (
    <div className="flex justify-between space-y-1 w-full flex-col md:flex-row gap-2 md:gap-0 ">
      {" "}
      <div className="flex flex-col md:gap-3 gap-1">
        {" "}
        <h1 className=" font-medium  text-[#242424] text-[24px] md:text-[32px] lg:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]">
          {title}
        </h1>
        {description && (
          <h3 className="text-[#242424] font-normal  md:leading-[28px] tracking-[0.025em] ">
            {description}
          </h3>
        )}
      </div>
      {!!children && children}
    </div>
  );
};
export default BodyHeader;
